export default __webpack_public_path__ + "static/media/GA_Zoom-4.0cbb44cb.wav";